var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modality",class:{
    MR: 'MR' === _vm.modality,
    CT: 'CT' === _vm.modality,
    PET: 'PET' === _vm.modality,
    Sound: 'Sound' === _vm.modality,
  }},[_vm._v(" "+_vm._s(_vm.modality)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }